import DojoView from "csi/page/DojoView";
import { Box, FlexColumn, FormControlLabel, GridColumn, ListItem, Message, Switch } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { useCreateSharedDataSheetsStore } from "./CreateSharedDataSheetsWizardStore";
import { ExpandableList } from "src/Sourcing/components/ExpandableList";

export const SelectDataSheetsTable = observer(() => {
	const store = useCreateSharedDataSheetsStore();
	const { dataSheetType, sourceTables, showOnlyNewSharedDataSheets, toggleDataSheets, switchLabel, refreshCounter, nodeUrl, viewId } = store;

	const titleRes = "CreateSharedDataSheets_SelectDataSheetsMessage";

	const dataSheetTables = sourceTables.map((source) => {
		const table = (
			(!source.canHideTable || !showOnlyNewSharedDataSheets) && (
				<ListItem key={source.sourceId}>
					<Box growNoOverflow>
						<DojoView
							forceRefresh={refreshCounter}
							fullHeight
							key={source.sourceId}
							nodeUrl={nodeUrl}
							viewId={viewId} 
							viewNodeType={dataSheetType}
							viewParams={source.viewParams}
						/>
					</Box>
				</ListItem>
			)
		);
		return (
			(!source.canHideTable || !showOnlyNewSharedDataSheets) && (
				<GridColumn
					standardBorder
				>
					<ExpandableList
						expanded = {!source.canHideTable}
						items={[table]}
						key={source.sourceId}
						title={source.sourceNode.$Name}
					/>
				</GridColumn>
			)
		);
	});

	return (
		<FlexColumn gap={3} p={5}>
			<Message
				titleRes={titleRes}
				variant="info"
			/>
			<FormControlLabel
				block
				control={<Switch checked={showOnlyNewSharedDataSheets} onChange={toggleDataSheets} />}
				label={switchLabel}
				labelPlacement="start"
			/>
			{dataSheetTables}
		</FlexColumn>
	);
});